// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "webfontloader" + "." + "316dc3f50636fb7e" + ".js";
};